import NativeInterface from "../../services/NativeInterface"

export enum MapControlPosition {
    BottomCenter = 'BottomCenter',
    RightBottom = 'RightBottom',
    RightTop = 'RightTop',
    LeftBottom = 'LeftBottom'
}

export interface ControlBtnInfo {
    id?: string,
    image: string,
    size: string,
    padding?: string,
    margin?: string,
    round?: boolean,
    position: MapControlPosition,
    callback?: () => void
}

function ctrlPosToGoogle(pos: MapControlPosition) {
    switch (pos) {
        case MapControlPosition.BottomCenter :
            return google.maps.ControlPosition.BOTTOM_CENTER;
        case MapControlPosition.RightBottom :
            return google.maps.ControlPosition.RIGHT_BOTTOM;
        case MapControlPosition.RightTop :
                return google.maps.ControlPosition.RIGHT_TOP;
        case MapControlPosition.LeftBottom :
            return google.maps.ControlPosition.LEFT_BOTTOM;
        default:
             return google.maps.ControlPosition.TOP_CENTER;
    }
}

export interface ControlsProps {
    buttons?: ControlBtnInfo[]
    recenterCallback?: () => void
    contentFilter?: {
        categories: string[]
        changeCallback: (category: string, isChecked: boolean) => void
    }
}

function mapTypeImage(type: google.maps.MapTypeId) {
    return type != google.maps.MapTypeId.ROADMAP
           ? 'img/map_type_roadmap.png'
           : 'img/map_type_satellite.png'
}

export class ControlsLayer {
    map: google.maps.Map
    config?: ControlsProps
    customButtons: HTMLElement[] = []

    constructor(map: google.maps.Map, config: ControlsProps | undefined) {
        this.map = map

        if (NativeInterface.isPWA()) {
            this.addControlBtn(map, {
                image: 'img/recenter.png',
                size: '48px',
                position: MapControlPosition.RightBottom,
                margin: '0 10px 10px 0',
                round: true,
                callback: config?.recenterCallback
            })
        }

        this.addControlBtn(map, {
            id: 'map_type_image',
            image: mapTypeImage(map.getMapTypeId() as google.maps.MapTypeId),
            size: '48px',
            position: MapControlPosition.LeftBottom,
            margin: '0 0 0 10px',
            callback: () => {
                const type = map.getMapTypeId() != google.maps.MapTypeId.ROADMAP
                             ? google.maps.MapTypeId.ROADMAP
                             : google.maps.MapTypeId.SATELLITE;
                map.setMapTypeId(type)
                const controlImage = document.getElementById('map_type_image') as HTMLImageElement;
                if (controlImage) {
                    controlImage.src = mapTypeImage(type)
                }
            }
        })
        this.configure(config)
    }

    configure(config: ControlsProps | undefined) {
        console.log("ControlsLayer.configure")
        this.config = config
        for (const btn of this.customButtons) {
            this.removeControlBtn(this.map, btn)
        }
        this.customButtons = []
        if (config?.buttons) {
            for (const ctrl of config?.buttons) {
                this.customButtons.push(this.addControlBtn(this.map, ctrl))
            }
        }
    }

    addControlBtn(map: google.maps.Map, info: ControlBtnInfo)
    {
        const controlDiv = document.createElement('div');
        const controlStyle: React.CSSProperties = {
            padding: info.padding ? info.padding : '0',
            margin: info.margin ? info.margin : '0',
            border: '2px solid white',
            borderRadius: info.round ? '50%' : '5px',
            cursor: 'pointer',
            backgroundColor: 'white',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.9)',
            boxSizing: 'border-box',
            lineHeight: '0',  // Reset line-height
        };
        Object.assign(controlDiv.style, controlStyle);
      
        const controlImage = document.createElement('img');
        if (info.id) {
            controlImage.id = info.id;
        }
        controlImage.src = info.image;
        controlImage.style.width = info.size;
        controlImage.style.height = info.size;
        controlImage.style.padding = '0px';
        controlImage.style.margin = '0px';
        controlImage.style.objectFit = 'cover';
        controlImage.style.borderRadius = info.round ? '50%' : '2px';
        controlDiv.appendChild(controlImage);

        if (info.callback) {
            controlDiv.addEventListener('click', info.callback);
        }
        map.controls[ctrlPosToGoogle(info.position)].push(controlDiv);
        return controlDiv
    }

    removeControlBtn(map: google.maps.Map, button: HTMLElement) {
        for (const position in map.controls) {
            const controls = map.controls[position];
            for (let i = 0; i < controls.getLength(); i++) {
                if (controls.getAt(i) === button) {
                    controls.removeAt(i);
                    return;
                }
            }
        }
    }
}